export const types = {
  BUSINESS: {
    TYPE_ID: 2,
    TEXT_KEY: 'business',
  },
  FOOD: {
    TYPE_ID: 1,
    TEXT_KEY: 'food',
  },
  DESIGN: {
    TYPE_ID: 12,
    TEXT_KEY: 'design',
  },
  MENU_ITEM_SIZE: {
    TYPE_ID: 13,
    TEXT_KEY: 'menuitem-size',
  },
  SPICE_LEVEL: {
    TYPE_ID: 14,
    TEXT_KEY: 'spice-level',
  },
  WEIGHT_UNIT: {
    TYPE_ID: 19,
    TEXT_KEY: 'weight.unit',
  },
  MAJOR_COLOR: {
    TYPE_ID: 23,
    TEXT_KEY: 'design.majorColor ',
  },
  DESIGN_SIZE: {
    TYPE_ID: 22,
    TEXT_KEY: 'design-size',
  },
};
